import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9bc3b2ca"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9bc3b2ca&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9bc3b2ca')) {
      api.createRecord('9bc3b2ca', component.options)
    } else {
      api.reload('9bc3b2ca', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9bc3b2ca", function () {
      api.rerender('9bc3b2ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/memberTourists/edit/index.vue"
export default component.exports